import React from 'react';

import Page from 'components/page/page.component';

import './style.css';

const PressReleases = () => {
    return (
        <Page
            heroTitle="Press Releases"
            heroText="Here are announcements from Muncie Land Bank along with a list of articles from local media that mention Muncie Land Bank."
            heroSize="small"
        >
            <div className="press-releases">
                <div className="press-release">
                    <h4 className="press-release-title">
                        Muncie Land Bank Takes on Blighted Properties
                    </h4>
                    <h5 className="press-release-date">MAY 16, 2020, Authored By: Muncie Land Bank</h5>
                    <p>
                        Muncie, IN—The Muncie Land Bank is a 501(c)(3) organization that works to eliminate the negative
                        effects of vacant, abandoned, and blighted properties in the City of Muncie. Blighted properties
                        lead to the lowering of property values, uncut grass, trash dumping, high crime, and depletion
                        of the local tax base.
                    </p>
                    <p>
                        In July 2016, the State of Indiana passed IC 36-7-38 into law enabling cities to establish land
                        banks. In July 2017, the City of Muncie passed an ordinance establishing the Muncie Land Bank.
                        The Board of Directors of the Muncie Land Bank is appointed by the Mayor, the City Council, the
                        Delaware County Treasurer, and the Board itself. The Board functions independently from the
                        government and other organizations.
                    </p>
                    <p>
                        In the City of Muncie, there are approximately 2400 vacant lots, 1300 vacant structures, and 750
                        blighted structures. This amounts to approximately $2.3 million in lost tax revenue due to
                        blight, vacancy, and abandonment.
                    </p>
                    <p>
                        Through funding and support provided by the City of Muncie, Delaware County, the Ball Brothers
                        Foundation, the Vectren Foundation, The Community Foundation, the Muncie Redevelopment
                        Commission, and the Ball State University Department of Urban Planning, the Muncie Land Bank has
                        incorporated and is now preparing, via the City’s Blight Elimination Program, to acquire ten
                        (10) blighted properties in the City of Muncie for redevelopment by the private sector and
                        public sector entities.
                    </p>
                    <p>
                        The Muncie Land Bank, with support from our elected officials, neighborhood leaders, citizens,
                        business leaders, foundations, nonprofits, sponsors, and area organizations, shall strive to
                        eliminate the negative conditions of vacant and blighted properties in our community and
                        neighborhoods. Thereby, continuing to make the City of Muncie a great place for family growth
                        and business development.
                    </p>
                </div>
            </div>
        </Page>
    );
};

export default PressReleases;
